import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { Api } from '../../../../api/gse/api';
import { getAllPmNotifications } from '../../../../api/gse/fn/maintenance-schedules/get-all-pm-notifications';
import { createPmNotificationJobCard } from '../../../../api/gse/fn/maintenance-schedules/create-pm-notification-job-card';
import { getMaintenanceSchedule } from '../../../../api/gse/fn/maintenance-schedules/get-maintenance-schedule';
import * as PmNotificationActions from './pm-notification.actions';

@Injectable()
export class PmNotificationEffects {
  private actions$ = inject(Actions);
  private api = inject(Api);

  loadPmNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PmNotificationActions.loadPmNotifications),
      switchMap(({ params }) =>
        from(this.api.invoke(getAllPmNotifications, params)).pipe(
          map((response) =>
            PmNotificationActions.loadPmNotificationsSuccess({
              data: response.data ?? [],
              totalRecords: response.page?.totalElements ?? response.data?.length ?? 0,
              page: response.page?.page || 0,
              last: !!response.page?.last,
            })
          ),
          catchError((err) =>
            of(PmNotificationActions.loadPmNotificationsFailure({ error: err }))
          )
        )
      )
    )
  );

  createPmJobCard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PmNotificationActions.createPmJobCard),
      switchMap(({ params }) =>
        from(this.api.invoke(createPmNotificationJobCard, params)).pipe(
          map((response) =>
            PmNotificationActions.createPmJobCardSuccess({
              message: response?.message,
            })
          ),
          catchError((err) =>
            of(PmNotificationActions.createPmJobCardFailure({ error: err }))
          )
        )
      )
    )
  );

  loadPmNotificationDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PmNotificationActions.loadPmNotificationDetails),
      switchMap(({ id }) =>
        from(this.api.invoke(getMaintenanceSchedule, { id })).pipe(
          mergeMap((response) => {
            const data = response.data;
            if (data == null) {
              return of(
                PmNotificationActions.loadPmNotificationDetailsFailure({
                  error: new Error('Maintenance schedule response had no data'),
                })
              );
            }
            return of(PmNotificationActions.loadPmNotificationDetailsSuccess({ data }));
          }),
          catchError((err) =>
            of(PmNotificationActions.loadPmNotificationDetailsFailure({ error: err }))
          )
        )
      )
    )
  );
}
